import type { ProductionBudgetView } from '@/api/studio-production'

/** 进入制片项目时：总剩余额低于此积分则弹预警（未充值走「请先设置」）。 */
export const PRODUCTION_BUDGET_LOW_THRESHOLD = 100

export type ProductionBudgetAlertKind = 'missing' | 'low'

export function productionBudgetRemaining(budget: ProductionBudgetView): number {
  const dept = (budget.departments ?? []).reduce((sum, d) => sum + (d.sub_pool_balance ?? 0), 0)
  return (budget.pool_balance ?? 0) + dept
}

export function productionBudgetAlertKind(budget: ProductionBudgetView): ProductionBudgetAlertKind | null {
  if ((budget.total_funded ?? 0) <= 0) return 'missing'
  if (productionBudgetRemaining(budget) < PRODUCTION_BUDGET_LOW_THRESHOLD) return 'low'
  return null
}
